import * as React from 'react';

import BonusIcon from './assets/BonusIcon.svg';
import DiscountIcon from './assets/DiscountIcon.svg';
import MaternalCapitalIcon from './assets/MaternalCapitalIcon.svg';
import MortgageIcon from './assets/MortgageIcon.svg';
import { EType } from '../../../../../types/villagePromotions';

export function getPromoIcon(type: EType): React.ReactElement {
  switch (type) {
    case 'sale':
      return <img src={DiscountIcon} />;
    case 'mortgage':
      return <img src={MortgageIcon} />;
    case 'bonus':
      return <img src={BonusIcon} />;
    case 'maternalCapital':
      return <img src={MaternalCapitalIcon} />;
    case 'militaryMortgage':
      return <img src={MortgageIcon} />;
  }

  return <img />;
}
